// Nouveau fichier: src/hooks/useConfirmation.js
import { useState } from 'react';

const useConfirmation = () => {
  const [confirmationState, setConfirmationState] = useState({
    isOpen: false,
    title: '',
    message: '',
    onConfirm: null,
    onCancel: null,
    confirmText: 'Confirmer',
    cancelText: 'Annuler',
    type: 'danger',
    details: null,
  });

  const showConfirmation = config => {
    setConfirmationState({
      isOpen: true,
      ...config,
    });
  };

  const hideConfirmation = () => {
    setConfirmationState(prev => ({
      ...prev,
      isOpen: false,
    }));
  };

  const handleConfirm = () => {
    if (confirmationState.onConfirm) {
      confirmationState.onConfirm();
    }
    hideConfirmation();
  };

  const handleCancel = () => {
    if (confirmationState.onCancel) {
      confirmationState.onCancel();
    }
    hideConfirmation();
  };

  return {
    confirmationState,
    showConfirmation,
    hideConfirmation,
    handleConfirm,
    handleCancel,
  };
};

export default useConfirmation;
